export {
  TRUNCATED_TEXT_TOOLTIP_CONTENT_CLASS,
  TruncatedTextWithTooltip,
  type TruncatedTextWithTooltipProps,
} from './TruncatedTextWithTooltip';
